import React from 'react';
import { PropertyFormData } from './types';
import { FormErrors } from '../../../types';

interface PropertyInfoSectionProps {
  propertyData: Pick<PropertyFormData, 'name' | 'description'>;
  errors: FormErrors;
  onChange: (field: 'name' | 'description', value: string) => void;
}

const PropertyInfoSection: React.FC<PropertyInfoSectionProps> = ({
  propertyData,
  errors,
  onChange
}) => {
  return (
    <div className="form-section-content">
      <div className="app-form-group">
        <label htmlFor="propertyName" className="app-form-label required">
          Property Name
        </label>
        <input
          id="propertyName"
          type="text"
          className={`app-form-input ${errors.name ? 'error' : ''}`}
          value={propertyData.name}
          onChange={(e) => onChange('name', e.target.value)}
          placeholder="Enter property name"
          maxLength={50}
        />
        {errors.name && <div className="app-form-error">{errors.name}</div>}
      </div>

      <div className="app-form-group">
        <label htmlFor="propertyDescription" className="app-form-label">
          Description
        </label>
        <textarea
          id="propertyDescription"
          className={`app-form-input ${errors.description ? 'error' : ''}`}
          value={propertyData.description}
          onChange={(e) => onChange('description', e.target.value)}
          placeholder="Enter property description (optional)"
          rows={3}
          maxLength={200}
        />
        {errors.description && <div className="app-form-error">{errors.description}</div>}
      </div>
    </div>
  );
};

export default PropertyInfoSection;
